var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.HeaderCustom,{attrs:{"title":"Gestão do Conhecimento"}},[_c(_setup.CardParametrosConsulta),_c('v-row',{staticClass:"mt-4"},[_c('v-col',[_c(_setup.ResultadoConsulta,{directives:[{name:"show",rawName:"v-show",value:(_setup.result?.totalHits),expression:"result?.totalHits"}]})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }